import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/pages/login/login'
import test from '@/components/pages/login/test'
import register from '@/components/pages/login/register'
import index from '@/components/pages/myIndex/index'
import search from '@/components/pages/page/search'
import searchResult from '@/components/pages/page/searchResult'
import SteelMallResult from '@/components/pages/page/mySteelMall/SteelMallResult'
import searchWareHouse from '@/components/pages/page/searchWareHouse'
import searchMaterialQualityList from '@/components/pages/page/searchMaterialQualityList'
import aboutUs from '@/components/pages/page/aboutUs.vue'
import mySteelMall from '@/components/pages/page/mySteelMall/mySteelMall'
import purchaseRelease from '@/components/pages/page/mySteelMall/purchaseRelease'
import myGoodsDetail from '@/components/pages/page/mySteelMall/myGoodsDetail'
import myOrderDelivery from '@/components/pages/page/mySteelMall/myOrderDelivery'
import orderPayConfirm from '@/components/pages/page/mySteelMall/orderPayConfirm'
import helpSubList from '@/components/pages/page/help/helpSubList'
import helpDetail from '@/components/pages/page/help/helpDetail'
import help from '@/components/pages/page/help/help'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/index',
      name: 'index',
      redirect: '//',
      component: index,
      children: [
        {
          path: '/help',
          name: 'help',
          redirect: '/helpSub',
          component: help,
          children: [
            {
              path: '/helpSub',
              name: 'helpSubList',
              component: helpSubList
            },
            {
              path: '/helpDetail',
              name: 'helpDetail',
              component: helpDetail
            }
          ]
        },
        {
          path: '/search',
          name: 'search',
          component: search
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: aboutUs
        },
        {
          path: '/searchResult',
          name: 'searchResult',
          component: searchResult
        },
        {
          path: '/SteelMallResult',
          name: 'SteelMallResult',
          component: SteelMallResult
        },
        {
          path: '/purchaseRelease',
          name: 'purchaseRelease',
          component: purchaseRelease
        },
        {
          path: '/searchWareHouse',
          name: 'searchWareHouse',
          component: searchWareHouse
        },
        {
          path: '/searchMaterialQualityList',
          name: 'searchMaterialQualityList',
          component: searchMaterialQualityList
        },
        {
          path: '//',
          name: 'mySteelMall',
          component: mySteelMall
        },
        {
          path: '/myGoodsDetail',
          name: 'myGoodsDetail',
          component: myGoodsDetail
        },
        {
          path: '/myOrderDelivery',
          name: 'myOrderDelivery',
          component: myOrderDelivery
        },
        {
          path: '/orderPayConfirm',
          name: 'orderPayConfirm',
          component: orderPayConfirm
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js